export const alerts = {
    state: {
        status: 'idle',
        alerts: [],
        areAllFetched: false,
        pagination: {
            limit: 20,
            page: 1
        },
        query: {
            status_symbol: 'published'
        }
    },
    mutations: {
        SET_ALERTS_STATUS(state, status) {
            state.status = status
        },
        SET_ALERTS(state, alerts) {
            state.alerts = alerts
        },
        SET_ALERTS_QUERY(state, payload) {
            this.$vue.set(state.query, payload.name, payload.value)
        },
        SET_ALERTS_PAGINATION_PAGE(state, page) {
            state.pagination.page = page
        },
        SET_ALERTS_ALL_FETCHED(state, areAllFetched) {
            state.areAllFetched = areAllFetched
        }
    },
    actions: {
        fetchAlerts({ state, commit, dispatch, getters }) {
            commit('SET_ALERTS', [])
            commit('SET_ALERTS_STATUS', 'loading')
            return dispatch('resetAlertsPagination').then(() => {
                return this.$api.get(`api/alerts.json?${getters.alertsQueryString}`).then((response) => {
                    commit('SET_ALERTS', response.data.data)
                    commit('SET_ALERTS_ALL_FETCHED', response.data.total_count ? response.data.total_count <= state.alerts.length : response.data.data.length === 0)
                    commit('SET_ALERTS_STATUS', 'idle')
                }).catch(error => {
                    commit('SET_ALERTS_STATUS', 'error')
                    return Promise.reject(error)
                })
            })
        },
        fetchAlertsNextPage({ state, commit, getters }) {
            if (state.areAllFetched) {
                return false
            }
            commit('SET_ALERTS_STATUS', 'loadingMore')
            commit('SET_ALERTS_PAGINATION_PAGE', state.pagination.page + 1)
            return this.$api.get(`api/alerts.json?${getters.alertsQueryString}`).then((response) => {
                commit('SET_ALERTS', state.alerts.concat(...response.data.data))
                commit('SET_ALERTS_ALL_FETCHED', response.data.total_count ? response.data.total_count <= state.alerts.length : response.data.data.length === 0)
                commit('SET_ALERTS_STATUS', 'idle')
            }).catch(error => {
                commit('SET_ALERTS_STATUS', 'error')
                return Promise.reject(error)
            })
        },
        setAlertsSearchQuery({ state, commit }, payload) {
            // check if payload has valid properties
            if (Object.prototype.hasOwnProperty.call(payload, 'name') &&
                Object.prototype.hasOwnProperty.call(payload, 'value')) {
                commit('SET_ALERTS_QUERY', payload)
            } else {
                console.error('Invalid payload')
            }
        },
        resetAlertsQuery({ commit, dispatch }) {
            commit('SET_ALERTS_ALL_FETCHED', false)
            return dispatch('resetFromInitialState', {
                module: 'alerts',
                object: 'query'
            })
        },
        resetAlertsPagination({ commit, dispatch }) {
            commit('SET_ALERTS_ALL_FETCHED', false)
            return dispatch('resetFromInitialState', {
                module: 'alerts',
                object: 'pagination'
            })
        }
    },
    getters: {
        alertsStatus: (state) => {
            return state.status
        },
        alerts: (state) => {
            if (state.alerts) {
                return state.alerts
            }
        },
        alertsQuery: (state) => {
            return state.query
        },
        alertsQueryString: (state) => {
            const pagination = `page=${state.pagination.page}&limit=${state.pagination.limit}`
            const params = Object.entries(state.query)
                .filter(([key, value]) => value !== '')
                .map(([key, val]) => `${key}=${encodeURIComponent(val)}`)
                .join('&')
            return `${pagination}&${params}`
        }
    }
}
